import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class ThresholdsService {

  static getAll(options=[], minimal=false) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');      
      axios.get(`${ROOT}thresholds${params}&minimal=${minimal}`).then((data) => {
        resolve({ thresholds: data.data.content, page: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static listAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}thresholds/listAll`).then((data) => {
        resolve({ thresholds: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static get(thresholdId, detail=false) {
    return new Promise((resolve, reject) => {
      let detailParms = detail ? '?projection=detail' : '';
      axios.get(`${ROOT}thresholds/${thresholdId}${detailParms}`).then((data) => {
        resolve({ threshold: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static isAssociated(thresholdId) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}thresholds/${thresholdId}/associated`).then((data) => {
        resolve({ associated: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAssociatedAlerts(thresholdId) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}thresholds/${thresholdId}/alerts`).then((data) => {
        resolve({ alerts: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }


  static save(threshold,thresholdId) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}thresholds/${thresholdId}`, threshold).then((data) => {
        resolve({ threshold: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static add(threshold) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}thresholds`, threshold).then((data) => {
        resolve({ threshold: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static remove(thresholdId) {
    return new Promise((resolve, reject) => {
      axios.delete(`${ROOT}thresholds/${thresholdId}`).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default ThresholdsService;
